// Lightweight acquisition-channel attribution. Captures the ?ref= (or utm_source)
// tag once on first touch and persists it, so every downstream conversion
// (care-lead, institution inquiry, signup) can be rolled into one funnel view.
const REF_KEY = 'cl_ref';

export function captureRef() {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = p.get('ref') || p.get('utm_source');
    if (ref) localStorage.setItem(REF_KEY, ref.slice(0, 40));
  } catch (_) { /* storage unavailable */ }
}

export function getRef() {
  try {
    return localStorage.getItem(REF_KEY) || null;
  } catch (_) {
    return null;
  }
}
